// extracted by mini-css-extract-plugin
export default {"logo":"logo__jvXpTlj4NCdHGy9gSkvud","logoWhale":"logoWhale__1K0tY8gXkIKaVxHh4__SuB","logoText":"logoText__1RUygDZzKuj9m5WUrQfQ2g"};